export const textFieldCustomizations = {
  MuiTextField: {
    defaultProps: {
      variant: "outlined",
      size: "medium",
      fullWidth: true,
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        fontSize: "0.95rem",
        borderRadius: 8,
      },
      input: {
        padding: "12px",
      },
    },
  },
};
